import { render, staticRenderFns } from "./search-results-light.vue?vue&type=template&id=30d61cbc"
import script from "./search-results-light.vue?vue&type=script&lang=js"
export * from "./search-results-light.vue?vue&type=script&lang=js"
import style0 from "./search-results-light.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports